export const WHATSAPP_URL =
  "https://wa.me/6285808664767?text=Hello%20Bedsolving%2C%20I%27d%20like%20to%20discuss%20my%20property.";
export const BOOKING_URL = "https://circle.bedsolving.id";
export const HR_EMAIL = "hr@bedsolving.id";
export const EMAIL = "inquiry@bedsolving.id";
export const PHONE = "+62 858 0866 4767";

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "How We Work", href: "#process" },
  { label: "About", href: "#journey" },
  { label: "Careers", href: "#careers" },
  { label: "Insights", href: "#insights" },
  { label: "FAQ", href: "#faq" },
];

export const STATS = [
  { value: "2014", label: "Serving Bali since" },
  { value: "37", label: "Hotels & villas managed" },
  { value: "7", label: "Bali regions" },
  { value: "85%+", label: "Average occupancy" },
];

export const REGIONS = ["Sanur", "Seminyak", "Ubud", "Kintamani", "Uluwatu", "Nusa Lembongan", "Nusa Penida"];

export const SERVICES = [
  {
    key: "operations",
    title: "Hotel Operations",
    text: "Full operational responsibility — front desk, housekeeping, F&B, and guest experience that drives loyalty.",
    tags: ["Front desk", "Housekeeping", "F&B"],
  },
  {
    key: "revenue",
    title: "Revenue Management",
    text: "Data-driven pricing and channel optimization built for the Indonesian market. We consistently outperform benchmarks.",
    tags: ["Dynamic pricing", "OTA channels"],
  },
  {
    key: "branding",
    title: "Branding & Marketing",
    text: "From visual identity to OTA positioning, social media, and direct booking campaigns that fill rooms.",
    tags: ["Identity", "Social", "Direct booking"],
  },
  {
    key: "consulting",
    title: "Hospitality Consulting",
    text: "Targeted advice on operations, revenue strategy, pre-opening planning, and investment feasibility.",
    tags: ["Pre-opening", "Feasibility"],
  },
];

export const STEPS = [
  { title: "Property Assessment", text: "We review your property, market position and current performance to identify the opportunity." },
  { title: "Tailored Agreement", text: "We propose a management agreement built around your goals — from full operations to targeted consulting." },
  { title: "Onboarding & Launch", text: "Branding, OTA positioning, pricing setup and team alignment so your property launches to our standard." },
  { title: "Operate & Report", text: "Day-to-day operations and revenue management, with transparent performance reporting to owners." },
];

export const JOBS = [
  {
    title: "E-Commerce Manager",
    dept: "E-Commerce",
    meta: ["Bali", "Work from home"],
    about: "We are looking for an experienced E-Commerce Manager to drive digital sales and revenue growth for Bedsolving Indonesia. You will lead our e-commerce strategies, boost online bookings, and strengthen our digital presence in the competitive hospitality market.",
    lists: [
      { heading: "Key Responsibilities", items: [
        "Manage and optimize hotel listings across major OTAs and direct booking channels.",
        "Develop digital strategies and marketing campaigns to increase online revenue.",
        "Analyze performance metrics and customer behavior to improve conversion rates.",
        "Collaborate with marketing and revenue teams on dynamic pricing and promotions.",
        "Oversee website functionality to ensure a smooth, user-friendly booking process.",
        "Build strong relationships with OTA partners to negotiate rates and inventory.",
        "Manage the e-commerce budget, track ROI, and monitor industry trends.",
      ] },
      { heading: "What We're Looking For", items: [
        "1+ years of e-commerce experience, preferably in the hospitality or travel industry.",
        "Deep understanding of OTA partnerships, booking platforms, and digital marketing.",
        "Strong analytical skills with a background in revenue management and pricing strategies.",
        "Proven track record of successfully growing online bookings and digital revenue.",
        "Bachelor's degree in Business, Marketing, Hospitality, or a related field.",
        "Fluent in English; familiarity with the Bali hospitality market is highly preferred.",
      ] },
      { heading: "What We Offer", items: [
        "Competitive salary package.",
        "Clear career growth opportunities within an expanding company.",
        "Ongoing training, industry certifications, and professional development.",
        "A collaborative and dynamic work environment in vibrant Bali.",
        "Work from home.",
      ] },
    ],
    cta: "Ready to drive our digital growth?",
  },
  {
    title: "Reservation Officer",
    dept: "Reservations",
    meta: ["Bali"],
    about: "We are looking for a highly organized and detail-oriented Reservation Officer to join Bedsolving Indonesia. As the first point of contact for our guests, you will manage inquiries and bookings across direct channels and Online Travel Agencies (OTAs). In this role, you will maintain accurate rates and availability while collaborating closely with our operations team to ensure a seamless, welcoming experience for every guest from booking to check-in.",
    lists: [
      { heading: "Key Responsibilities", items: [
        "Respond promptly and professionally to guest inquiries and booking requests.",
        "Accurately process all reservations, modifications, and cancellations.",
        "Manage property availability and bookings via our Property Management System (PMS) and major OTA platforms (e.g., Airbnb, Booking.com).",
        "Ensure rates, inventory, and booking details are consistently updated across all sales channels.",
        "Issue booking confirmations and share essential pre-arrival details with guests.",
        "Liaise with the operations team to prepare for guest arrivals, accommodate special requests, and ensure villa readiness.",
        "Maintain meticulously accurate booking records and generate reservation reports.",
        "Uphold company Standard Operating Procedures (SOPs) and high service standards.",
      ] },
      { heading: "Qualifications", items: [
        "Diploma or Degree in Hospitality, Tourism, or a related field.",
        "1–2 years of experience in reservations, front office, or a similar role within the villa or boutique hotel sector.",
        "Fluent in both spoken and written English, with excellent communication skills.",
        "Hands-on experience with PMS, Channel Managers, and OTA platforms.",
        "Highly responsive, detail-oriented, and capable of multitasking in a fast-paced environment.",
        "Proficient in Microsoft Office and Google Workspace.",
      ] },
    ],
    cta: "Ready to help deliver exceptional guest experiences?",
  },
];

export const FAQS = [
  {
    q: "What does Bedsolving do?",
    a: "Bedsolving is a professional hotel management company based in Bali, founded in 2014. We manage 37 independent hotels and villas across 7 regions of Bali, providing full hotel operations, revenue management, OTA distribution, branding, and hospitality consulting.",
  },
  {
    q: "Which regions of Bali does Bedsolving operate in?",
    a: "Our portfolio spans 7 Bali regions: Sanur, Seminyak, Ubud, Kintamani, Uluwatu, Nusa Lembongan, and Nusa Penida — covering boutique hotels, villas, homestays, and eco-resorts.",
  },
  {
    q: "How does Bedsolving help hotel owners increase occupancy?",
    a: "We deliver an average occupancy rate above 85% through data-driven revenue management, multi-channel OTA distribution (Booking.com, Agoda, Expedia, Airbnb), dynamic pricing, and targeted digital marketing — backed by 11 years of Bali hospitality expertise.",
  },
  {
    q: "What properties does Bedsolving manage?",
    a: "Bedsolving manages a curated portfolio of 37 properties across Bali — boutique hotels, private villas, homestays, and eco-resorts. Each property meets our quality and service standards.",
  },
  {
    q: "How can I list my hotel or villa with Bedsolving?",
    a: "Contact us at inquiry@bedsolving.id or call +62 858 0866 4767. Our team will assess your property and discuss a management agreement tailored to your goals.",
  },
  {
    q: "How long has Bedsolving been operating?",
    a: "Bedsolving was founded in Bali in 2014 and has been operating for over 11 years, growing to manage 37 properties and establishing itself as one of Bali's leading independent hotel management companies.",
  },
];


export const DEFAULT_CONTENT = {
  booking_url: BOOKING_URL,
  hero: {
    eyebrow: "Serving Bali Since 2014",
    title_line1: "Trusted by Owners.",
    title_line2: "Loved by",
    title_highlight: "Guests.",
    subtitle: "37 handpicked hotels and villas across 7 Bali regions — managed to one standard of excellence.",
  },
  stats: STATS,
  regions: REGIONS,
  services_intro: {
    title: "Full-Service Property Management",
    text: "Four pillars, one mission — operations, revenue, marketing, and consulting, all under one roof.",
  },
  services: SERVICES.map(({ title, text, tags }) => ({ title, text, tags })),
  community: {
    title: "Community",
    text: "We contribute to the Ragam Foundation — setting aside a portion of earnings to support social initiatives across Bali.",
  },
  process: {
    title: "From first conversation to full performance.",
    text: "A clear, four-step partnership process for hotel and villa owners.",
    steps: STEPS,
  },
  journey: {
    title: "Rooted in Bali.",
    highlight: "Built for Results.",
    text: "Since 2014, we've grown from a single property to 37 handpicked hotels and villas — each managed with the same care and precision as the first.",
    milestones: [
      { year: "2014", text: "Founded in Bali with a single property." },
      { year: "11+ yrs", text: "Of Bali hospitality expertise." },
      { year: "Today", text: "37 hotels and villas across 7 regions." },
    ],
  },
  faqs: FAQS,
  contact: {
    title: "Ready to Grow Your Property?",
    text: "Whether you own a boutique hotel or a multi-property portfolio, Bedsolving has the expertise, technology, and network to take your business further.",
    email: EMAIL,
    phone: PHONE,
    whatsapp_number: "6285808664767",
    hr_email: HR_EMAIL,
  },
};
